// extracted by mini-css-extract-plugin
export default {"container":"styles_container__YpeCo","layout":"styles_layout__T9Z9X","sidebar":"styles_sidebar__yLIEz","mainContent":"styles_mainContent__fX5gK"};